import { useContext, useEffect, useState } from 'react';
import { useMsal } from "@azure/msal-react";
import useWindowSize from '../../hooks/useWindowSize';
import BelowUltraWideMenu from './components/BelowUltraWideMenu/BelowUltraWideMenu';
import UltraWideMenu from './components/UltraWideMenu/UltraWideMenu';
import AppDataContext from '../../context/AppDataContext';
import useUserPicture from '../../hooks/useUserPicture';

export default function Menu() {
  const { instance, accounts } = useMsal();
  const {isUltraWide } = useWindowSize();
  const {imageUrl } = useUserPicture();
  const { setUser } : any = useContext(AppDataContext);
  const account = accounts && accounts[0];

  useEffect(()=> {
        if(account){
          setUser({
              "fullName": account.name,
              "userName": account.username,
              "email": account.username,
              "picture": imageUrl,
          });
        }

    }, [imageUrl])


    // Logout
    const logOut = ()=> {
      localStorage.setItem("isLogout", "true");
      instance.logoutRedirect();
    }

  return (
    <>
    {
      (<BelowUltraWideMenu handleLogout={logOut} />)
      // isUltraWide? (<UltraWideMenu handleLogout={logOut} />) : (<BelowUltraWideMenu handleLogout={logOut} />)
    }
    </>
  )
}
